<div class="uk-section ">
    <div class="uk-container uk-flex-center">
        <div class="uk-child-width-1-3@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div  uk-lightbox="animation: fade">
             
                    <a class="uk-inline" href="assets/screen13.webp" data-caption="Caption 1">
                        <img src="assets/screen13.webp" alt="" uk-img>
                    </a>
                </div>
           
            <div  uk-lightbox="animation: fade">
             
                    <a class="uk-inline" href="assets/screen14.jpg" data-caption="Caption 1">
                        <img src="assets/screen14.jpg"  alt="" uk-img></a>
                </div>
          
            <div  uk-lightbox="animation: fade">
                
                    <a class="uk-inline" href="assets/screen15.jpg" data-caption="Caption 1">
                        <img src="assets/screen15.jpg"  alt="" uk-img></a>
               
            </div>
            <div  uk-lightbox="animation: fade">
                
                    <a class="uk-inline" href="assets/screen16.jpg" data-caption="Caption 1">
                        <img src="assets/screen16.jpg"  alt="" uk-img></a>
               
            
       
    </div>
</div>
